var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ChannelItem d-flex align-items-center",
      attrs: { title: _vm.channel.value },
    },
    [
      _c("ChannelIcon", {
        staticClass: "mr-2",
        class: _vm.validationStatusColor,
        attrs: { type: _vm.channel.type },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-mono text-truncate" }, [
        _vm._v(_vm._s(_vm.channel.value)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }